module.exports = __webpack_public_path__ + "static/media/onboarding-trivia-image1.5efd60e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/onboarding-trivia-image1.png
// module id = 2710
// module chunks = 0